// extracted by mini-css-extract-plugin
export default {"wavyGradientTextSpan":"RdCqYNugsWwyAQC6IvqW","levitate":"FAW4Ym63RxY3WD3jKY5i","transparentColor":"Ma5_cW2S1ZuEsx944oPw"};